<mat-card class="card" fxLayout="column" ngClass.xs="xs" [ngStyle]="getStyle">
  <mat-card-header fxLayout="column" fxLayoutAlign="center center">
    <ng-content select="[header]"></ng-content>
    <app-icon *ngIf="headerIcon" [name]="headerIcon" (click)="onClickHeaderIcon()"></app-icon>
    <h1 class="header" [ngStyle]="titleStyle">
      {{ title }}
    </h1>
    <p *ngIf="subtitle" [ngStyle]="subtitleStyle">
      {{ subtitle }}
    </p>
  </mat-card-header>
  <mat-card-content>
    <ng-content select="[content]"></ng-content>
  </mat-card-content>
  <mat-card-actions fxLayout="column" class="flex" style="align-self: center;">
    <ng-content select="[buttons]"></ng-content>
  </mat-card-actions>
</mat-card>
